module.exports = __webpack_public_path__ + "img/plan_2.96d0da4c.jpg";